import { InfiniteInsightItem } from '../types/infiniteLanding.types'

export const INFINITE_LANDING_INSIGHT_CAROUSEL_ITEMS: InfiniteInsightItem[] = [
  {
    title: 'Asset Allocation',
    description: 'What should be my ideal portfolio mix and SIP strategy?',
    icon: '/images/infinite/decisions/asset_allocation.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Timely Rebalancing',
    description: 'Is this the right time to make portfolio changes?',
    icon: '/images/infinite/decisions/timely_rebalancing.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Home Buying',
    description: 'How should I invest if I want to buy a house in 5 years?',
    icon: '/images/infinite/decisions/home_buying.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Key Life Events',
    description: 'How should I plan my son’s wedding?',
    icon: '/images/infinite/decisions/wedding 1.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Retirement',
    description: 'How should I plan for my retirement?',
    icon: '/images/infinite/decisions/retirement.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Gold & Silver',
    description: 'Do I need safe haven metals in my portfolio?',
    icon: '/images/infinite/decisions/gold_and_silver.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Global Exposure',
    description: 'Do I need to invest beyond India?',
    icon: '/images/infinite/decisions/global_exposure.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Portfolio consolidation',
    description: 'How do I bring my funds down to the ‘right’ few?',
    icon: '/images/infinite/decisions/portfolio_consolidation.png',
    titleClassName: 'text-[16px] text-[#000000]'
  },
  {
    title: 'Taxes',
    description: 'How do I make changes tax efficiently?',
    icon: '/images/infinite/decisions/taxes.png',
    titleClassName: 'text-[16px] text-[#000000]'
  }
]
